import React from "react";
import { Container, Flex, Text, Box, Title } from "@mantine/core";

import InfiniteLogoBanner from "../InfiniteLogoBanner";
export const FeaturedIn = () => {
  return (
    <Box>
      <InfiniteLogoBanner />
      <Text fz="10px" m="0" p="0" top="-2px" pos="relative" style={{ color: "#94a3b8", letterSpacing: "0.03em" }}>
        Inspiration
      </Text>
    </Box>
  );
};
